/* NINspirAtion - leere Akkordeon-Zeilen ausblenden
   Eine Zeile (z. B. "Personalisierung") wird aus einem Metafeld gespeist.
   Fehlt das Metafeld, bliebe die Zeile leer stehen - das sieht aus wie ein Fehler.
   Im Theme-Editor bleibt alles sichtbar, damit dort weiter bearbeitet werden kann. */
(function () {
  function ninHideEmptyAccordionRows() {
    if (window.Shopify && window.Shopify.designMode) return;

    var contents = document.querySelectorAll('.details-content');

    Array.prototype.forEach.call(contents, function (content) {
      if (content.getAttribute('data-nin-checked') === '1') return;
      content.setAttribute('data-nin-checked', '1');

      var hasMedia = content.querySelector('img, svg, video, iframe, input, select, button, a, table, ul, ol');
      var text = (content.textContent || '').replace(/ /g, ' ').trim();
      if (text !== '' || hasMedia) return;

      var row = content.closest ? content.closest('details') : null;
      if (!row) return;

      var target = row;
      var parent = row.parentElement;
      if (parent && parent.children.length === 1 && parent.tagName.indexOf('-') > -1) {
        target = parent;
      }

      target.style.display = 'none';
      target.setAttribute('data-nin-empty', '1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ninHideEmptyAccordionRows);
  } else {
    ninHideEmptyAccordionRows();
  }

  window.setTimeout(ninHideEmptyAccordionRows, 1000);
  document.addEventListener('shopify:section:load', ninHideEmptyAccordionRows);
})();
